import { Link, useForm } from '@inertiajs/inertia-react';
import Button from 'app/components/Buttons/Button';
import usePageProps from 'app/components/hooks/usePageProps';
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals';
import { ScreenContext } from 'app/components/ScreenContext';
import { UserType } from 'app/components/Types/UserType';
import { formatDuration, stringToColorCode } from 'app/utils/utils';
import moment from 'moment';
import { duration } from 'moment';
import React, { createContext, useContext, useEffect, useRef } from 'react'
import route from 'ziggy-js';
import Checkbox from './Forms/Checkbox';
import DoubleDatePicker from './Forms/DoubleDatePicker';
import Form, { FormContext } from './Forms/Form';
import Submit from './Forms/Submit';
import TSlideContainer from './TSlideContainer';
import { UserCard } from './UserCard';

interface Props {
    user: UserType
}


function DataButton({ text, start, end, empty = false }) {



    return (
        <Link className="py-11px px-24px bg-green-539648 rounded-md m-5px text-white font-semibold cursor-pointer hover:bg-green-539648/70 mob:w-full"
            href={route(route()?.current() ?? 'index', { ...(route()?.params ?? {}), start: start, end: end, empty: empty })}
            // preserveState
            preserveScroll
            only={['stats', 'start', 'end', 'empty']}
            as="button"
        >
            {text}
        </Link>
    );
}



function TxtArea(props) {

    const ref = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.style.height = ref.current.scrollHeight + "px";
        }
    }, [ref.current])

    return (
        <textarea ref={ref} className='bg-gray-1C1C1C p-20px rounded outline-none border-none w-full min-h-max resize-none' readOnly >{props.export_script}</textarea>
    );
}


function ColumnGraph(props: Props) {
    const { user } = props

    const { stats, start, end, empty } = usePageProps<{ stats: any, start, end, empty }>();
    const { open } = useContext(ModalsContext)
    const { isMobile } = useContext(ScreenContext)


    const form = useForm({
        start: moment(start).format('DD. MM. YYYY'),
        end: moment(end).format('DD. MM. YYYY'),
        empty: empty,
    });
    const { data, get } = form;



    let hours = Math.ceil(Math.max(...(Object.values(stats.per_day ?? { 0: 0 }) as Array<number>)));
    let trackings = stats.per_day_trackings;

    let days = {};

    let day = moment(start);

    if (!!data['empty']) {
        do {
            let key = day.format('DD-MM-YYYY');
            days[key] = trackings[key] ?? [];
        }
        while (day.add(1, 'day').isBefore(moment(end)));
    }
    else {
        days = trackings;
    }

    let count = Object.keys(days ?? {}).length;

    let hs = hours > 0 ? [...Array(hours).keys()].reverse() : [0];

    function rtnq(number) {
        return Math.round(number * 4) / 4;
    }

    let export_data = Object.keys(stats?.per_project_total ?? {}).map(key => ({ name: key, amount: rtnq((Object.values(stats.per_project_total[key] ?? {}) as Array<number>)?.reduce((carry, item) => carry.add(item, 'hours'), duration()).asHours()), unit: 'hodin', price_vat: ['Baranek Resorts', 'Timea', 'DM - DevSupport', 'New timea'].includes(key) ? 275 : 300 }));
    let export_script = "javascript:(() => {" + JSON.stringify(export_data) + ".forEach((row, index) => Object.keys(row).forEach((key, i) => { var el = document.getElementById(`item_${index}_${key}`); if (!el) document.getElementsByClassName('invoice_item_add_link')[0].click(); el = document.getElementById(`item_${index}_${key}`); el.value = row[key] } ) ) })()";

    const submit = (e) => {
        e.preventDefault();

        get(route(route()?.current() ?? 'index', { user: user.UUID, start: start, end: end, empty: !!data['empty'] }),
            {
                preserveState: false,
                preserveScroll: true,
                only: ['stats', 'start', 'end', 'empty']
            }
        )
    }

    const Container = isMobile ? TSlideContainer : 'div';


    return (

        <div className='px-30px overflow-hidden pb-60px'>

            <div className="flex flex-col ">
                <div>
                    {
                        user.UUID == 'GALATEX' &&
                        <>
                            <a href={export_script} onClick={e => e.preventDefault()} title="Drag me to bookmarks and then click me while creating new invoice in Fakturovac. Then Delete me. :)" className="bg-green-539648 hover:bg-green-539648/70 rounded-full p-8px my-26px inline-flex">Export Bookmarklet</a>
                            {/* <TxtArea export_script={export_script} /> */}
                        </>
                    }
                    <Container title='Filters' containerStyles='w-full  bg-gray-1C1C1C p-12px rounded items-center'>
                        <Form form={form} onSubmit={submit} className="flex items-start mt-40px bg-gray-1C1C1C p-12px rounded justify-between mob:flex-wrap mob:mt-0">
                            <div className="flex items-center flex-wrap gap-20px gap-y-6px mob:flex-wrap">
                                <div className="flex flex-wrap gap-y-12px pt-16px">
                                    <DoubleDatePicker />
                                </div>
                                <div className='flex gap-12px mob:flex-wrap'>
                                    <DataButton
                                        text="Last year"
                                        start={moment().startOf('year').subtract(1, 'year').format('DD. MM. YYYY')}
                                        end={moment().subtract(1, 'year').endOf('year').format('DD. MM. YYYY')}
                                        empty={!!data['empty']}
                                    />
                                    <DataButton
                                        text="This Year"
                                        start={moment().startOf('year').format('DD. MM. YYYY')}
                                        end={moment().endOf('year').format('DD. MM. YYYY')}
                                        empty={!!data['empty']}
                                    />
                                    <DataButton
                                        text="Last month"
                                        start={moment().startOf('month').subtract(1, 'month').format('DD. MM. YYYY')}
                                        end={moment().subtract(1, 'month').endOf('month').format('DD. MM. YYYY')}
                                        empty={!!data['empty']}
                                    />
                                    <DataButton
                                        text="This month"
                                        start={moment().startOf('month').format('DD. MM. YYYY')}
                                        end={moment().endOf('month').format('DD. MM. YYYY')}
                                        empty={!!data['empty']}
                                    />
                                    <DataButton
                                        text="This week"
                                        start={moment().startOf('week').format('DD. MM. YYYY')}
                                        end={moment().endOf('week').format('DD. MM. YYYY')}
                                        empty={!!data['empty']}
                                    />
                                </div>
                            </div>
                            <div className="flex items-center justify-end min-w-max gap-20px">
                                <div className='mt-12px'>
                                    <Checkbox name="empty" label="Show empty?" />
                                </div>

                                <Submit className='mb-12px' name='show' value="Zobrazit" />
                            </div>
                        </Form>
                    </Container>
                </div>
                <Container title='Overview' containerStyles='w-full  bg-gray-1C1C1C p-12px rounded mb-12px mt-12px items-center'>

                    <div className="w-full flex  bg-gray-1C1C1C p-12px rounded mb-12px mt-12px items-center flex-wrap">
                        {
                            Object.keys(stats?.per_project_total ?? {}).map(key =>

                                <div className=" p-5px flex items-center my-4px mr-16px bg-white bg-opacity-8 rounded">
                                    <div className="w-20px h-20px flex-shrink-0 rounded" style={{ backgroundColor: stringToColorCode(key) }}></div>
                                    <div className="text-center flex ml-12px items-center">
                                        <div>{key} -&nbsp;</div>
                                        <div>{formatDuration((Object.values(stats.per_project_total[key] ?? {}) as Array<number>)?.reduce((carry, item) => carry.add(item, 'hours'), duration()))}</div>
                                    </div>
                                </div>
                            )
                        }
                        <div className="p-5px flex items-center my-4px bg-white bg-opacity-8 rounded">
                            <div className="w-20px h-20px flex-shrink-0 rounded" style={{ backgroundColor: stringToColorCode('Total') }}></div>
                            <div className="text-center flex ml-12px items-center">
                                <div>Total -&nbsp;</div>
                                <div>{formatDuration(duration().add(stats.total_hours, 'hours'))}</div>
                            </div>
                        </div>
                    </div>
                </Container>
                <div className="w-full relative flex">
                    <div className=" w-full flex items-end flex-shrink bg-gray-1C1C1C p-12px rounded overflow-hidden">
                        <div className="absolute left-1px w-full bottom-80px pb-16px px-16px pointer-events-none">
                            {
                                hs.map(i =>
                                    <hr className="border-t border-white border-dashed w-full mt-45px -mb-1px" />
                                )
                            }
                        </div>
                        <div className="flex flex-col mb-80px pb-4px">
                            {
                                hs.map((a, i) =>
                                    <div className="flex shrink-0 whitespace-nowrap h-45px items-end ">
                                        {a} h
                                    </div>
                                )
                            }
                        </div>
                        <div className='w-full flex items-end flex-shrink overflow-auto overflow-y-hidden pl-6px tagscrollbar'>
                            {
                                Object.keys(days ?? {}).map(key =>

                                    <div className={`w-full flex flex-col flex-shrink ${count > 31 ? (count > 62 ? "p-1px" : "p-2px") : 'p-4px'} min-w-24px max-w-xxs `}  >
                                        <div className="flex flex-col col flex-grow rounded-t-sm overflow-hidden -mb-1px">

                                            {
                                                [...days[key]]?.reverse().map(tracking =>

                                                    <a onClick={() => open(MODALS.EDITTRACKING, false, { tracking_id: tracking.id })} className={`border-b border-b-gray-1C1C1C segment  text-10 relative flex items-center justify-center overflow-hidden cursor-pointer `} title={`${tracking.project_name} / ${tracking.task_name} [${tracking.total} h]`} style={{ backgroundColor: stringToColorCode(tracking.project_name), height: duration().add(tracking.total, 'hours').asHours() * 45, cursor: 'pointer' }}>
                                                        <div className={`absolute px-2px text-center leading-none rounded-sm text-shadow ${count > 31 ? 'write-v-rl transform rotate-180 whitespace-nowrap overflow-hidden py-3px' : ''}`}>{count > 31 ? (`${formatDuration(duration().add(stats.per_day[key] ?? 0, 'hours'))} `) : tracking.task_name}</div>
                                                    </a>
                                                )
                                            }

                                        </div>
                                        <div className='flex-shrink flex-grow-0 h-80px relative flex items-start justify-center'>
                                            <div className="absolute text-center mt-4px break-all transform write-v-rl flex flex-col justify-center items-end rotate-195 -ml-15px leading-none h-80px max-h-80px max-w-80px  overflow-hidden pb-5px">
                                                <div className="text-10"> {key}</div>
                                                {count < 62 && <div className="text-10">{formatDuration(duration().add(stats.per_day[key] ?? 0, 'hours'))}</div>}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <TSlideContainer title='Trackings' containerStyles='w-full p-12px bg-gray-1C1C1C rounded my-24px' contentStyles='flex flex-col gap-8px mt-8px'>
                    {
                        Object.keys(days ?? {}).map(key =>

                            <div className={`w-full flex flex-col bg-white/5 rounded  px-16px py-12px gap-6px`}  >
                                <div className=''>
                                    <div className=" flex justify-between gap-16px text-18 font-semibold">
                                        <div className=""> {moment(key, 'DD-MM-YYYY').format('DD. MM. YYYY')}</div>
                                        <div className="">{formatDuration(duration().add(stats.per_day[key] ?? 0, 'hours'))}</div>
                                    </div>
                                </div>
                                <div className="flex flex-col flex-grow gap-2px rounded-t-sm rounded-b-sm overflow-hidden -mb-1px">

                                    {
                                        [...days[key]]?.reverse().map(tracking =>

                                            <a onClick={() => open(MODALS.EDITTRACKING, false, { tracking_id: tracking.id })} className={`bg-slate-800 relative flex items-center justify-between cursor-pointer py-6px px-16px`} title={`${tracking.project_name} / ${tracking.task_name} [${tracking.total} h]`} style={{ backgroundColor: stringToColorCode(tracking.project_name), cursor: 'pointer' }}>
                                                <div className={`px-2px text-center leading-none rounded-sm text-shadow `}>{tracking.task_name}</div>
                                                <div className={`px-2px text-center leading-none rounded-sm text-shadow `}>{`${tracking.total} h`}</div>
                                            </a>
                                        )
                                    }

                                </div>

                            </div>
                        )
                    }
                </TSlideContainer>

            </div>
        </div>
    )
}

export default ColumnGraph
